module.exports = __webpack_public_path__ + "img/nandu-parking-plan.b1a7e8aa.png";